<share-buttons [theme]="'moon'"
               [include]="btns"
               [size]="size"
               [url]="url"
               [autoSetMeta]="false"></share-buttons>
<app-share-email [url]="url" *ngIf="showEmail"></app-share-email>
